<template>
  <div class="inn-input">
    <div class="dialog-add-account__form-col">
      <div class="dialog-add-account__form-item">
        <div
          class="form-input"
          :class="[
            { 'form-input--full': value },
            { 'form-input--error': error || (serverErrors && serverErrors.inn) },
          ]"
        >
          <input
            :value="value"
            @input="handleInput"
            type="text"
            required
            :disabled="innInputDisabled"
          />
          <span class="form-input__label">
            {{ label || $t('business_account_data.inn') }}
          </span>
          <div v-if="error" class="form-input__error" v-text="error" />
          <div v-if="serverErrors && serverErrors.inn" class="form-input__error">
            <p v-for="(err, index) in serverErrors.inn" :key="index">
              {{ err }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Кнопка проверки ИНН -->
    <div
      v-if="showCheckButton && (!isValidated || allowRecheckWhenValidated)"
      class="dialog-add-account__form-col"
    >
      <ButtonElement
        :text="$t('button_props.check_tin')"
        :disabled="!value || loading"
        @click-button="handleCheck"
      />
    </div>

    <!-- Поле ФИО после успешной проверки -->
    <div v-if="isValidated && showFioField" class="dialog-add-account__form-col">
      <div class="dialog-add-account__form-item">
        <div
          class="form-input"
          :class="[
            { 'form-input--full': fio },
            { 'form-input--error': fioError || (serverErrors && serverErrors.fio) },
          ]"
        >
          <input
            :value="fio"
            @input="handleFioInput"
            type="text"
            required
            :disabled="fioInputDisabled"
          />
          <span class="form-input__label">
            {{ fioLabel || $t('business_account_data.full_name') }}
          </span>
          <div v-if="fioError" class="form-input__error" v-text="fioError" />
          <div v-if="serverErrors && serverErrors.fio" class="form-input__error">
            <p v-for="(err, index) in serverErrors.fio" :key="index">
              {{ err }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonElement from '@/components/elements/ButtonElement';
import { validateInnFormat } from '@/utils/forms/innValidation';

export default {
  name: 'InnInput',
  components: {
    ButtonElement,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    fio: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    fioError: {
      type: String,
      default: '',
    },
    serverErrors: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    innDisabled: {
      type: Boolean,
      default: false,
    },
    fioDisabled: {
      type: Boolean,
      default: false,
    },
    isValidated: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showCheckButton: {
      type: Boolean,
      default: true,
    },
    // Если нужно показывать кнопку даже после успешной проверки (например, чтобы перепроверить)
    allowRecheckWhenValidated: {
      type: Boolean,
      default: false,
    },
    showFioField: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    fioLabel: {
      type: String,
      default: '',
    },
    checkAction: {
      type: String,
      default: 'Ad/checkInnReferral', // или 'Ad/checkInn' для обычной проверки
    },
  },
  computed: {
    innInputDisabled() {
      return this.disabled || this.innDisabled;
    },
    fioInputDisabled() {
      return this.disabled || this.fioDisabled;
    },
  },
  methods: {
    handleInput(event) {
      const newValue = event.target.value;
      this.$emit('input', newValue);
      // Если ИНН изменен, сбрасываем статус валидации
      if (this.isValidated && newValue !== this.value) {
        this.$emit('validation-reset');
      }
    },
    handleFioInput(event) {
      this.$emit('update:fio', event.target.value);
    },
    handleCheck() {
      // Базовая валидация формата перед отправкой на сервер
      const validation = validateInnFormat(this.value);

      if (!validation.isValid) {
        this.$emit('error', this.$t(validation.error));
        return;
      }

      this.$emit('check', this.value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.inn-input {
  display: contents; // Позволяет элементам быть частью родительской grid/flex структуры
}
</style>
